import { v4 as uuidv4 } from 'uuid';

import { SearchParameters } from '../../state/types';
import { reportSearchBegin } from '../../telemetry/report/protobuf/events';
import { reportSearchSubmitted } from '../../telemetry/report/protobuf/search';
import { GenericThunkAction } from '../../types';
import { findById as findGroup } from '../groups/selectors';

import { getSearchSessionConversationId, getSearchSessionConversationStart } from './selectors';
import { SearchSessionEndAction, SearchSessionStartSessionAction, SearchSessionSubmitSearchAction } from './types';

type SubmitSearch = (searchParameters: SearchParameters) => GenericThunkAction<SearchSessionSubmitSearchAction>;
export const submitSearch: SubmitSearch =
  ({ searchText, endTimestamp, startTimestamp, resultType, groupScope: groupId }) =>
  (dispatch, getState) => {
    const state = getState();
    const logicalId = uuidv4();

    const conversationId = getSearchSessionConversationId(state);
    const groupTelemetryId = groupId ? findGroup(state, groupId)?.telemetryId : undefined;
    const length = searchText.length;
    const wordCount = searchText.split(' ').filter((word) => word !== '').length;
    const conversationStart = getSearchSessionConversationStart(state);

    reportSearchSubmitted(
      resultType,
      {
        logicalId,
        conversationId,
        queryLength: length,
        wordCount,
        conversationStart,
      },
      {
        dateFilterStartTimestamp: startTimestamp,
        dateFilterEndTimestamp: endTimestamp,
        groupTelemetryId,
      }
    );

    return dispatch({
      type: 'SEARCH.SUBMIT',
      payload: {
        logicalId,
      },
    });
  };

type StartSearchSession = (
  currentSearchBoxText: string | undefined,
  beganSearchFrom: string,
  language: string,
  isTeamsSearch?: boolean
) => GenericThunkAction<SearchSessionStartSessionAction>;
export const startSearchSession: StartSearchSession =
  (currentSearchBoxText, beganSearchFrom, language, isTeamsSearch) => (dispatch) => {
    const conversationId = uuidv4();
    const logicalId = uuidv4();
    const conversationStart = Date.now();
    const isRefinement = !!currentSearchBoxText?.length;

    reportSearchBegin({
      conversationId,
      beganSearchFrom,
      isRefinement,
      language,
      isTeamsSearch,
    });

    return dispatch({
      type: 'SEARCH.START_SESSION',
      payload: {
        conversationId,
        conversationStart,
        logicalId,
      },
    });
  };

type EndSearchSession = () => SearchSessionEndAction;
export const endSearchSession: EndSearchSession = () => ({
  type: 'SEARCH.END_SESSION',
});
